import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import { DropdownDictionary } from '@cupoui/shared/model/dropdownDictionary';

@Component({
    selector: 'app-drop-down-multi',
    templateUrl: './drop-down-multi.component.html',
    styleUrls: ['./drop-down-multi.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropDownMultiComponent {


  @Input() name: string;
  @Input() items: DropdownDictionary[];
  @Input() selectedItems: DropdownDictionary[];
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() closeOnSelect: boolean = true;
  @Output() selectedItemsChange = new EventEmitter();
  @Output() saveModel = new EventEmitter();
  @Output() open = new EventEmitter();
  @Input() testId: string;
  empty: boolean = false;

  constructor() { }

  onChange() {
    this.selectedItemsChange.emit(this.selectedItems);
  }

  onOpen() {
    this.open.emit();
  }

  onSaveModel() {
    this.empty = false;
    this.saveModel.emit();
  }

  onSaveState(){
    this.empty = true;
  }

  close() {
    this.empty = false;
  }

  displayMultiLabel(): string {
    if (this.empty || !this.items || !this.selectedItems) {
      return '';
    }
    if(this.selectedItems.length === 1 && this.items.length !== 0) {
      const test = this.items.filter(e => e === this.selectedItems[0]);
      return test.length !== 0 ? test[0].name : '-';
    }
    return this.selectedItems.length + ' selected';
  }
}
